
export const passageConfig = {
  ufliUrl : "https://research.dwi.ufl.edu/op.n/file/cbhd8xmn9i4ctf7i/?embed"
};

export const enagagementTabs = {
  startPage: 0,
  preEngagement: 1,
  passageEngagement: 2,
  postEngagement: 3,
  finalEngagement: 4,
  engagementReview: 5
}

export const passageTabs = {
  firstHearing: 0,
  pingPongGame: 1,
  secondHearing: 2
}

export const VIDEO_EMBED_URLS = {
  YOUTUBE_EMBED: 'https://www.youtube.com/embed/',
  YOUTUBE_WATCH: 'youtube.com/watch',
  YOUTUBE_SHORT: 'youtu.be',

  VIMEO_DOMAIN: 'vimeo.com',
  VIMEO_EMBED: 'https://player.vimeo.com/video/',

  DRIVE_DOMAIN: 'drive.google.com',
  DRIVE_VIEW: '/view',
  DRIVE_PREVIEW: '/preview',
};


export const errorMessages = {
  UPDATE_PROGRESS_FAILED : "Failed to update progress. Please try again!"
}
export const passageStyle = {
  HIGHLIGHT: {
    backgroundColor: '#FFD900'
  },
  NO_HIGHLIGHT: {
    backgroundColor: 'transparent'
  },
  UNDERLINE: {
    textDecoration: 'underline',
    textDecorationColor: '#00B0E0',
    textDecorationThickness: '3px'
  },
  NO_UNDERLINE: {
    textDecoration: 'none'
  }
};
export const sesssionConstants = {
  trainingSchoolUuid : '1000'
}